import React from 'react';
import styled from 'styled-components';
import { ReactComponent as HAALogo } from '../../assets/images/Logo/HardAssetsAllianceLogo.svg';
import GSLogo from '../../assets/images/Logo/GS-main-logo.png';
import ContosoLogo from '../../assets/images/Logo/ContosoLogo.png';
import config from '../../config';

const LogoStyles = styled.div`
  > img {
    height: 1.75rem;
    object-fit: contain;
  }
  > svg {
    height: 1.75rem;
    object-fit: contain;
    color: #ffffff;
  }
`;

const Logo = () => {
  const { brokerTheme } = config;

  if (brokerTheme === 'HardAssetsAlliance') {
    return (
      <LogoStyles>
        <HAALogo />
      </LogoStyles>
    );
  }

  if (brokerTheme === 'GoldSilver') {
    return (
      <LogoStyles>
        <img src={GSLogo} alt="Broker Logo" />
      </LogoStyles>
    );
  }

  if (brokerTheme === 'Contoso') {
    return (
      <LogoStyles>
        <img src={ContosoLogo} alt="Broker Logo" />
      </LogoStyles>
    );
  }

  return null;
};

Logo.propTypes = {};

export default Logo;
